export * from './array.util.js';
export * from './audio.util.js';
export * from './auth.util.js';
export * from './country-to-currency.js';
export * from './error.util.js';
export * from './event-emitter.js';
export * from './novu.js';
export * from './number.util.js';
export * from './podcast.util.js';
export * from './string.util.js';
export * from './test.util.js';
export * from './time.util.js';
export * from './typescript.util.js';
export * from './yupLocales.util.js';

export function getId(
  data:
    | (Record<string, any> & {
        _id: string;
      })
    | string,
) {
  if (typeof data === 'string') return data;
  return data._id;
}

export function isObjectIdStringified(id: any): id is string {
  return typeof id === 'string' && isValidObjectId(id);
}

export function isValidObjectId(id: string): boolean {
  return /^[a-f\d]{24}$/i.test(id);
}
